import { merge } from 'lodash';
export function configReducer(state, action) {
    return merge({}, state, action);
}
//# sourceMappingURL=reducer.js.map